"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import styles from './IllustratedMessage.module.scss.mjs';
import clsx from 'clsx';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';

const IllustratedMessage = (props) => {
  const { className, children, color = "primary", ...rest } = props;
  const rootClassName = clsx(
    styles.illustratedMessage,
    className,
    styles[color]
  );
  const lightOrDarkColor = color === "dark" || color === "light" ? color : void 0;
  const propsContext = {
    Icon: {
      className: styles.icon,
      size: "l"
    },
    Heading: {
      className: styles.heading
    },
    Text: {
      className: styles.text,
      color: lightOrDarkColor
    },
    Button: {
      color: lightOrDarkColor ?? "accent"
    },
    ActionGroup: {
      className: styles.actionGroup
    },
    ProgressBar: { className: styles.progressBar }
  };
  return /* @__PURE__ */ jsx("div", { ...rest, className: rootClassName, children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children }) });
};

export { IllustratedMessage, IllustratedMessage as default };
//# sourceMappingURL=IllustratedMessage.mjs.map
